
import { Component, input } from '@angular/core';
import { HoveredLeftMenuDirective } from '../../directives/hoveredLeftMenu.directive';
import { MenuTool } from '../../interfaces/MenuTool.interface';

@Component({
  selector: 'st-apps-tools-menu',
  standalone: true,
  imports: [HoveredLeftMenuDirective],
  templateUrl: './apps-tools-menu.component.html',
  styleUrls: ['./apps-tools-menu.component.scss'],
})
export class AppsToolsMenuComponent {
  tools = input.required<MenuTool[]>();
  menuOptions: any = {
    autoClose: false,
    menuWidth: '260px',
  };

  constructor() {}

  openTool(url: string) {
    window.open(url, '_blank');
  }
}
